import { supabase } from './supabase'

/**
 * Kiosk sipariş takibi (31 Eki 2026, supabase/kiosk-takip.sql): müşteri
 * kiosk ekranındaki karekodu telefonuyla okutur, girişsiz bir sayfada
 * siparişinin durumunu görür.
 */

export type TrackState = 'odeme' | 'sirada' | 'hazirlaniyor' | 'hazir' | 'teslim' | 'iptal'

export interface KioskTrack {
  business: string
  no: number | null
  code: string | null
  state: TrackState
  totalKurus: number
  items: { name: string; qty: number }[]
}

/** null: bulunamadı; 'expired': siparişin günü geçti. */
export async function fetchKioskTrack(token: string): Promise<KioskTrack | 'expired' | null> {
  if (import.meta.env.DEV && token === 'demo') return demoTrack()
  if (!supabase) throw new Error('Bağlantı yok.')
  const { data, error } = await supabase.rpc('kiosk_track', { p_token: token })
  if (error) throw new Error('Sipariş açılamadı.')
  if (!data) return null
  const r = data as Record<string, unknown>
  if (r.expired) return 'expired'
  return {
    business: String(r.business ?? ''),
    no: typeof r.no === 'number' ? r.no : null,
    code: typeof r.code === 'string' ? r.code : null,
    state: (r.state as TrackState) ?? 'odeme',
    totalKurus: Number(r.totalKurus ?? 0),
    items: Array.isArray(r.items)
      ? (r.items as Record<string, unknown>[]).map((i) => ({ name: String(i.name ?? ''), qty: Number(i.qty ?? 0) }))
      : [],
  }
}

/** Müşterinin takip sayfası; kiosk ekranında karekod olarak gösterilir. */
export const trackUrl = (token: string) => `https://adissoo.com/s/${token}`

/**
 * Okutulan yazıda takip anahtarını bulur. Okuyucu adresi klavye gibi yazıyor;
 * Türkçe klavyede "/" ve ":" bozulabildiği için adresin kendisine değil, sondaki
 * 16 karakterlik anahtara bakılıyor.
 */
export function tokenInScan(scan: string, tokens: string[]): string | undefined {
  const s = scan.toLowerCase()
  return tokens.find((t) => t && s.includes(t.toLowerCase()))
}

/**
 * Yalnız yerelde (/s/demo): video ve tasarım için, veritabanına dokunmadan
 * durumlar sırayla ilerler. Sayfa açıldıktan sonra her ~6 sn bir adım.
 */
const demoStart = Date.now()
function demoTrack(): KioskTrack {
  const steps: TrackState[] = ['odeme', 'sirada', 'hazirlaniyor', 'hazir', 'teslim']
  const step = Math.min(steps.length - 1, Math.floor((Date.now() - demoStart) / 6000))
  return {
    business: 'Orhanlı Burger',
    no: 12,
    code: '4821',
    state: steps[step],
    totalKurus: 59000,
    items: [
      { name: 'Klasik Burger', qty: 2 },
      { name: 'Patates Kızartması', qty: 1 },
      { name: 'Ayran', qty: 2 },
    ],
  }
}
